import React from "react";
import {
  Stepper,
  Step,
  StepLabel,
  Button,
  Box,
  Dialog,
  Paper,
  DialogTitle,
} from "@mui/material";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import AddIcon from '@mui/icons-material/Add';
import AddReceiptsReviewTable from "./AddReceiptsReviewTable";
import AddReceiptsMethodSelection from "./AddReceiptsMethodSelection";
import AddReceiptsUploadFile from "./AddReceiptsUploadFile";
import AddReceiptsManualInput from "./AddReceiptsManualInput";

interface AddReceiptsProps {
  open: boolean;
  handleClose: () => void;
}

const tableHeadings = {
  company: "Company",
  receipt_number: "Receipt Number",
  receipt_amount: "Receipt Amount",
  finance_company_id: "Finance Company ID",
};
const rows = [
  {
  company: "Boyle",
  receipt_number: "RC259001039",
  receipt_amount: "174.35",
  finance_company_id: "11325",
  },
   {
  company: "Entain",
  receipt_number: "RC259001039",
  receipt_amount: "12345.67",
  finance_company_id: "13587632",
  }
];

const AddReceiptsModal = ({ open, handleClose }: AddReceiptsProps) => {
  const steps = ["Method Selection", "Input", "Review & Save"];

  const [activeStep, setActiveStep] = React.useState(0);

  const handleNext = () => {
    if (activeStep === steps.length - 1) {
      handleSave();
    } else {
      setActiveStep((prev) => prev + 1);
    }
  };

  const handleBack = () => {
    if (activeStep > 0) {
      setActiveStep((prev) => prev - 1);
    }
  };

  const handleSave = () => {
    console.log("Saving data...");
    alert("Data saved successfully!");
  };

  // ----------------------------
  // STEP-WISE STATIC DEMO DATA
  // ----------------------------
  const renderStepContent = (step: number) => {
    switch (step) {
      case 0:
        return (
          <AddReceiptsMethodSelection/>
        );

      case 1:
        return (
          <>
           ---- %  This is for Upload File  %----

            <AddReceiptsUploadFile/>
          <br/>
          <br/>
          ---- %  This is for Manual Input  %----
          <br/>
          <br/>
            <AddReceiptsManualInput/>
          </>
        );

      case 2:
        return (
           <AddReceiptsReviewTable tableHeadings={tableHeadings} rows={rows} />
        );

      default:
        return "Unknown Step";
    }
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{ sx: { width: "900px", maxWidth: "900px" } }}
      >
        <Paper sx={{ padding: "16px 24px 20px 24px" }}>
          <DialogTitle sx={{ padding: "0px 0px 16px 0px" }}>
            Add New Receipt
          </DialogTitle>

          <Box sx={{ width: "100%", mt: 2 }}>
            <Stepper
              sx={{
                "& .MuiStepIcon-root": {
                  color: "rgba(0,0,0,0.3)", // default inactive
                },
                "& .MuiStepIcon-root.Mui-active": {
                  color: "secondary.main",
                },
                "& .MuiStepIcon-root.Mui-completed": {
                  color: "secondary.main",
                },
              }}
              activeStep={activeStep}
            >
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>

            {/* Step Content */}
            <Box
              sx={{
                my: 4,
                px: 1,
              }}
            >
              {renderStepContent(activeStep)}
            </Box>

            {/* Buttons */}
            <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}>
              <Button
                disabled={activeStep === 0}
                onClick={handleBack}
                color="secondary"
                sx={{ mr: 1 }}
              >
                Back
              </Button>

              <Button
                color="secondary"
                variant="outlined"
                onClick={handleClose}
                sx={{ mr: 1 }}
              >
                CANCEL
              </Button>

              <Button
                variant="contained"
                color="secondary"
                onClick={handleNext}
                endIcon={activeStep === steps.length - 1 ? <AddIcon sx={{ml:'0.5'}}/> : <ChevronRightIcon sx={{ml:'0.5'}}/>}
              >
                {activeStep === steps.length - 1 ? "Add receipt" : "Next"}
              </Button>
            </Box>
          </Box>

        </Paper>
      </Dialog>
    </>
  );
};

export default AddReceiptsModal;
